import * as actionTypes from './actionTypes';
import * as api from '../api';
import * as slowDataApi from '../../slow-data/api'
import { station as stationSchema, arrayOfStations as arrayOfStationsSchema, normalize } from '../../helpers/schema';

import { createActionObject, getNoArgDispatcherFunc, getAjaxFunc } from '../../helpers/common';
import { stationStatus } from '../constants';
import { snackBarVisiblePeriod } from '../../helpers/constants';

import * as strings from '../../helpers/strings';

export const search = criteria => dispatch => getAjaxFunc(
  actionTypes.SEARCH_STATIONS_REQUEST,
  "",
  actionTypes.SEARCH_STATIONS_FAILURE,
  "",
  dispatch
)(
  () => api.search(criteria)
    .then(({ status, message, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_STATIONS_FAILURE
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.SEARCH_STATIONS_SUCCESS,
              {
                ...normalize(data.list, arrayOfStationsSchema),
                totalRecord: data.totalRecord,
                totalPage: data.totalPage,
                startIndex: criteria.startIndex
              }
            )
          );
      }
    })
)()

export const create = (station) => dispatch => getAjaxFunc(
  actionTypes.CREATE_STATION_REQUEST,
  "",
  actionTypes.CREATE_STATION_REQUEST,
  strings.msgSaveFailed,
  dispatch
)(
  () => api.create({
    ...station
  })
    .then(({ status, message, data }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.CREATE_STATION_FAILURE,
              {
                message: message
              }
            )
          );
          break;
        case 403:
          dispatch(
            createActionObject(
              actionTypes.CREATE_STATION_FAILURE,
              {
                message: strings.msgStationNameAlreadyExisted
              }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.CREATE_STATION_SUCCESS,
              {
                ...normalize(data, stationSchema),
                message: strings.msgSavedSuccessfully,
                station: data
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const update = (station) => dispatch => getAjaxFunc(
  actionTypes.UPDATE_STATION_REQUEST,
  "",
  actionTypes.UPDATE_STATION_FAILURE,
  strings.msgSaveFailed,
  dispatch
)(
  () => api.update({
    ...station,
  })
    .then(({ status, data, message }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.UPDATE_STATION_FAILURE,
              {
                message: message
              }
            )
          );
          break;
        case 403:
          dispatch(
            createActionObject(
              actionTypes.UPDATE_STATION_FAILURE,
              {
                message: strings.msgStationNameAlreadyExisted
              }
            )
          );
          break;
        case 200:
          dispatch(
            createActionObject(
              actionTypes.UPDATE_STATION_SUCCESS,
              {
                message: strings.msgSavedSuccessfully
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.UPDATE_STATION_SUCCESS,
              {
                ...normalize(data, stationSchema),
                message: strings.msgSavedSuccessfully
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const archive = stationId => dispatch => getAjaxFunc(
  actionTypes.ARCHIVE_STATION_REQUEST,
  "",
  actionTypes.ARCHIVE_STATION_FAILURE,
  strings.msgArchivingFailed,
  dispatch
)(
  () => api.archive(stationId)
    .then(({ status }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.ARCHIVE_STATION_FAILURE,
              {
                message: strings.msgArchivingFailed
              }
            )
          );
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.ARCHIVE_STATION_SUCCESS,
              {
                message: strings.msgArchivedSuccessfully,
                stationId,
                status: stationStatus.archived
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const restore = stationId => dispatch => getAjaxFunc(
  actionTypes.RESTORE_STATION_REQUEST,
  "",
  actionTypes.RESTORE_STATION_FAILURE,
  strings.msgRestoringFailed,
  dispatch
)(
  () => api.restore(stationId)
    .then(({ status }) => {
      switch (status) {
        case 500:
          dispatch(
            createActionObject(
              actionTypes.RESTORE_STATION_FAILURE,
              {
                message: strings.msgRestoringFailed
              }
            )
          )
          break;
        default:
          dispatch(
            createActionObject(
              actionTypes.RESTORE_STATION_SUCCESS,
              {
                stationId,
                status: stationStatus.active,
                message: strings.msgRestoredSuccessfully
              }
            )
          );
          setTimeout(() => dispatch(
            createActionObject(
              actionTypes.CLOSE_SNACK_BAR
            )
          ), snackBarVisiblePeriod);
          break;
      }
    })
)()

export const selectStation = (station, multiSelect) => dispatch => {
  dispatch(
    createActionObject(
      multiSelect ? actionTypes.ADD_STATION_TO_SELECTIONS : actionTypes.SELECT_STATION,
      { station }
    )
  );

  if (!multiSelect) {
    slowDataApi.loadGraphReferences(station.id)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(
            createActionObject(
              actionTypes.FETCH_GRAPH_REFERENCE_SUCCESS,
              { graphReferences: data }
            )
          )
        }
      });
  }
}

export const selectFields = (field, multiSelect) => dispatch => {
  dispatch(
    createActionObject(
      multiSelect ? actionTypes.ADD_FIELDS_TO_SELECTIONS : actionTypes.SELECT_FIELDS,
      { field }
    )
  );
}

export const removeFieldsFromSelections = key => dispatch => dispatch(
  createActionObject(
    actionTypes.REMOVE_FIELDS_FROM_SELECTIONS,
    { key }
  )
)

export const removeStationFromSelections = index => dispatch => dispatch(
  createActionObject(
    actionTypes.REMOVE_STATION_FROM_SELECTIONS,
    { index }
  )
)

export const clearStationSelections = getNoArgDispatcherFunc(actionTypes.CLEAR_SELECTIONS)

export const clearFieldsSelections = getNoArgDispatcherFunc(actionTypes.CLEAR_FIELDS_SELECTIONS)

export const addNewStation = getNoArgDispatcherFunc(actionTypes.ADD_NEW_STATION)